export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            投稿爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            掌握第一手黑料？欢迎向我们投稿，一经采用将标注来源并优先展示
          </p>
        </div>
        <div className="bg-background-100 rounded-xl border border-background-200 p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div className="p-4">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <div className="text-sm font-medium text-foreground-800 mb-1">邮箱投稿</div>
              <div className="text-xs text-foreground-500">tips@chigua.example.com</div>
            </div>
            <div className="p-4">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <div className="text-sm font-medium text-foreground-800 mb-1">微信投稿</div>
              <div className="text-xs text-foreground-500">添加客服微信号投稿</div>
            </div>
            <div className="p-4">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-user-voice-line text-xl text-secondary-600"></i>
              </div>
              <div className="text-sm font-medium text-foreground-800 mb-1">匿名爆料</div>
              <div className="text-xs text-foreground-500">支持完全匿名提交信息</div>
            </div>
          </div>
          <div className="mt-6 p-4 bg-accent-50 border border-accent-200 rounded-lg text-center">
            <p className="text-xs md:text-sm text-foreground-600">
              <i className="ri-information-line text-accent-500 mr-1"></i>
              我们承诺严格保护投稿人隐私信息，所有投稿内容经过审核后发布。黑料独家入口期待你的爆料！
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}